export default __webpack_public_path__ + "static/media/logo.37bd9ef1.svg";